import { makeStyles } from "@material-ui/styles";

const teamLogoStyles = makeStyles((theme) => ({
	avatar: {
		backgroundColor: ({ backgroundColor, showBackgroundColor }) =>
			showBackgroundColor
				? `${backgroundColor} !important`
				: "transparent !important",
		color: ({ textColor }) => `${textColor} !important`,
		"& svg": {
			display: ({ showBackgroundColor }) => !showBackgroundColor && "none"
		},
		fontWeight: "normal",
		width: 50,
		height: 50,
		"& :hover": {
			backgroundColor: "unset !important"
		}
	},
	avatarSmall: {
		height: "35px !important",
		width: "35px !important"
	},
	avatarLarge: {
		height: 150,
		width: 150
	},
	teamLogoBox: {
		display: "flex",
		alignItems: "center",
		height: "unset !important",
		width: "unset !important",
		gap: theme.spacing(0.5),
		flexDirection: ({ teamNamePosition }) => {
			switch (teamNamePosition) {
				case "bottom":
					return "column";
				case "top":
					return "column-reverse";
				case "left":
					return "row-reverse";
				case "right":
					return "row";
				default:
					return "column";
			}
		}
	},
	teamLogoTypography: {
		"&.MuiTypography-body1": {
			color: ({ teamNameColor }) => teamNameColor,
			fontSize: ({ teamNameFontSize }) => teamNameFontSize
		}
	}
}));

export default teamLogoStyles;
